import React from 'react';
import './Auth.css';

const IPBannedScreen = () => {
  return (
    <div className="clerk-auth-container">
      <div className="ip-banned-card">
        <div className="clerk-auth-header">
          <div className="clerk-logo">
            <img src="/logo.png" alt="Logo" className="clerk-logo-image" />
          </div>
        </div>

        <div className="ip-banned-content">
          <div className="banned-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          
          <h2>Access Limited</h2>
          <p>Your access to this application has been limited.</p>
          
          <div className="contact-support">
            <p>If you believe this is an error, please contact support:</p>
            <a href="mailto:support@twizzler.app" className="support-link">
              support@twizzler.app
            </a>
          </div>
          
          <div className="error-details">
            <p className="error-code">Error Code: ACCESS_LIMITED</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IPBannedScreen; 